import { render } from "./SsbtVouchers.vue?vue&type=template&id=7c80d112"
import script from "./SsbtVouchers.vue?vue&type=script&lang=js"
export * from "./SsbtVouchers.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__